import store, { actions } from "../../redux";
import { CollaboratorProps } from "../../redux/slices/collaborator/Collaborator";
import { API_INSTANCES } from "../api_instance";
import { handleError } from "../errors";

const dispatch = store.dispatch;

const searchCollaborators = (
  payload: CollaboratorProps.setCollaboratorsPayload
) => {
  dispatch(actions.collaborator.setGetCollaborators_API_STATUS("progress"));
  return API_INSTANCES.GLOBAL.searchCollaborators(payload)
    .then((res) => {
      const data = res.data as CollaboratorProps.searchCollaboratorsResponse;
      dispatch(actions.collaborator.setCollaborators(data));
      dispatch(actions.collaborator.setGetCollaborators_API_STATUS("success"));
    })
    .catch((error) => {
      handleError(error, "searchCollaborators");
      dispatch(actions.collaborator.setGetCollaborators_API_STATUS("error"));
    });
};

export const GLOBAL = {
  searchCollaborators,
};
